import React from 'react';
import { contextMenu } from 'react-contexify';
import { useDispatch } from 'react-redux';

import { MENU_ID_HIDE, MENU_ID_SHOW } from './SonarTable';
import { selectSingleDomain } from '../../redux/sonar/sonarReducer';
import Tr from '../../components/common-table/components/Tr';
import TdCheckbox from '../../components/common-table/components/TdCheckbox';
import Td from '../../components/common-table/components/Td';
import TdDomain from '../../components/common-table/components/TdDomain';
import TdValue from '../../components/common-table/components/TdValue';

import scss from './SonarTable.module.scss';

function SonarTableItem({
  data = {},
  trendEvaluator,
  onChooseDomain,
  searchQuery,
  columns,
  rankKey,
  isShowGlobalRank,
}) {
  const { domain, companyName, isActive, inFocus, selected, marked, rank, companyLogo, myCompany } = data;
  const dispatch = useDispatch();

  const handleSelect = () => {
    dispatch(selectSingleDomain(domain));
  };

  const displayContextMenu = (event) => {
    contextMenu.show({
      id: isActive ? MENU_ID_HIDE : MENU_ID_SHOW,
      event,
      props: { domain },
    });
  };

  return (
    <Tr onContextMenu={displayContextMenu} isInactive={!isActive} isMarked={marked}>
      <TdCheckbox selected={selected} onSelect={handleSelect} />
      <Td extraClasses={scss.cellRank}>{!isShowGlobalRank && rankKey ? data[rankKey]?.rank : rank}</Td>
      <TdDomain
        domain={domain}
        logo={companyLogo}
        company={companyName}
        inFocus={inFocus}
        myCompany={myCompany}
        searchTerm={searchQuery}
        onChooseDomain={onChooseDomain}
        isLeft
      />
      {columns.map(({ key }) => (
        <TdValue key={key} data={data[key]} trendEvaluator={trendEvaluator} />
      ))}
    </Tr>
  );
}
export default SonarTableItem;
